import video from "./modules/video";
import window from "./modules/window";
import VideoSeat from "./modules/video-seat";
import webSocket from "./modules/web-socket";
import StreamSeat from "./modules/stream-seat";
import { createLogger, createStore } from 'vuex'
import Editor from "./modules/editor";
import live from "@/vuex/modules/live";


const store = createStore({
  state: {
    player: null
  },
  getters: {
    getPlayerData: (state) => player => state[player]
  },
  mutations: {
    setPlayer(state, {player, data}) {
      state[player] = data
    }
  },
  plugins: [createLogger()],
  modules: {
    video: video,
    videoSeat: VideoSeat,
    streamSeat: StreamSeat,
    webSocket: webSocket,
    editor: Editor,
    window: window,
    live: live
  }
})

export default store
